// node端的配置
console.log("[-> config/index.js] process.env", process.env, process.env.BASE_URL);
let subPath;
if(process.env.NODE_ENV==="development"){
  // 本地环境读取base.json
  subPath = '';
} else {
  try {
    // build环境，读取base.xx.json
    subPath = '.'+process.env.BASE_URL.replace('/', '').replace('/', '')
  } catch (e) {
    console.error("-> subPath has error", e);
    subPath = '';
  }
}
console.log("[-> config/index.js] subPath", subPath);

const baseConfig = require('./base'+subPath+'.json');
const nodeConfig = Object.assign({}, window.NODE_CONFIG);

// 前端的配置
let config = {
  // 项目目录
  publicPath: baseConfig.publicPath,
  // 接口地址前缀
  serviceHost: baseConfig.serviceHost,
  // 路由认证
  auth: baseConfig.authConfig,
  // Editor
  editorConfig: baseConfig.editorConfig
  // failCode: baseConfig.failCode
};
// 合并Node端配置
config = Object.assign(config, nodeConfig);
console.log('[-> CONFIG]', config);
window.CONFIG = config;

export default config
